import React, { Suspense, useState } from 'react';
import { LoadingSpinner } from '../../common/components/LoadingSpinner';
import { DrinksMenuDataList } from '../components/DrinksMenuDataList';
import { ListSearchAndLimit } from '../../common/components/ListSearchAndLimit';
import { PageFrame } from '../../common/components/PageFrame';
import { AddButton } from '../../common/components/AddButton';
import { SearchBar } from '../../common/components/SearchBar';

export const DrinksMenusListPage = () => {
  const [query, setQuery] = useState('');
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);

  return (
    <PageFrame
      title="Drinks Menus"
      topBarContent={
        <>
          <SearchBar
            placeholder="Search menus"
            onChange={setQuery}
            style={{ width: 220 }}
          />
          <AddButton text="Add Menu" to="/drinks-menus/add" />
        </>
      }
    >
      <ListSearchAndLimit
        onSearch={setQuery}
        limit={limit}
        setLimit={setLimit}
      />
      <Suspense fallback={<LoadingSpinner />}>
        <DrinksMenuDataList
          offset={offset}
          limit={limit}
          query={query}
          setOffset={setOffset}
        />
      </Suspense>
    </PageFrame>
  );
};
